import { useContext } from 'react'
import { alertContext, IAlertContext } from '../contexts/alertContext/alertContext'

const useAlert = () => {
    return useContext(alertContext) as IAlertContext
}

export default useAlert